// extracted by mini-css-extract-plugin
export default {"newsWrapper":"newsView_newsWrapper__vcFAT","newsItem":"newsView_newsItem__jWiiA","newsTitle":"newsView_newsTitle__e0a1o","img":"newsView_img__+G-xN","img1":"newsView_img1__ITYCR"};